
















































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import choiceGhost from '../components/choiceGhost.vue'
import editGhost from '../components/editGhost.vue'
// import choiceBedRoom from '../components/choiceBedRoom.vue'
import choiceBedRoom from '../components/NextChoiceBedRoom.vue'
import signature from '../components/signture.vue'

@Component({
    components: {
        choiceGhost,
        editGhost,
        choiceBedRoom,
        signature,
    },
})
export default class Playing extends Vue {
    private selectDoneLoading: boolean = false
    private showName: boolean = false
    private userName: string = ''
    private sex: string = 'boy' // 默认true 为 小哥哥
    private changeTopMargin: boolean = false // top margin
    private signature: boolean = false // 签名
    private btnActive: boolean = false // 被子选择了没
    private eitdMode: boolean = false // 小鬼编辑名称模式
    private step: number = 1 // 步骤
    private selectGhostShadow: object[] = [{}, {}, {}, {}, {}]
    private selectGhost: ghost[] = []
    private summon: boolean = false // 是否可以点击召唤按钮
    private quilt: any[] = [] // 被子款式
    private getSelectGhost () {
        this.selectGhost = JSON.parse(JSON.stringify(this._ref('ghost').selectGhosts))
        if (this.selectGhost.length === 3) {
            this.summon = true
        }
    }
    private changeName () {
        if (!this.userName) {
            return
        }
        localStorage.setItem('name', this.userName)
        if (this._ref('signature')) {
            this._ref('signature').name = this.userName
        }
        if (this._ref('bedRoom')) {
            this._ref('bedRoom').name = this.userName
        }
        this.showName = false
        setTimeout(() => {
            window.scrollTo(0, document.body.scrollTop + 1)
            if (document.body.scrollTop >= 1) {
                window.scrollTo(0, document.body.scrollTop - 1)
            }
        }, 100)
    }
    // @Watch('step')
    // private setWatch () {
    //     this._ref('bed-room').ghosts = []
    // }
    // ts包裹ref选择器
    private _ref (s: string) {
        const ref: any = this.$refs[s]
        return ref
    }
    private editMethod (v: ghost, index: number) {
        // @ts-ignore
        _hmt.push(['_trackEvent', 'nav', 'click', `editGhost=${v.index}`, v.index])
        this.eitdMode = true
        this.$nextTick(() => {
            this._ref('editGhost').name = v.name
            this._ref('editGhost').img = v.img
            this._ref('editGhost').bg = v.bg
            this._ref('editGhost').index = index
        })
    }
    private focusMethod () {
        setTimeout(() => {
            window.scrollTo(0, document.body.scrollTop + 1)
            if (document.body.scrollTop >= 1) {
                window.scrollTo(0, document.body.scrollTop - 1)
            }
        }, 100)
    }
    private summonMethod (value, event) {
        event ? event.preventDefault() : (() => 1)()
        this.step = value
        if (value === 2) {
            this.$nextTick(() => {
                for (const i of this.selectGhost) {
                    this._ref('bedRoom').ghosts.push({
                        name: i.name,
                        img: i.img
                    })
                }
            })
        }
    }
    // 选择性别
    private selectSex (value: string) {
        this.sex = value
        this._ref('bedRoom').personImg = require(`../assets/img_polaroid_sleep${value}@3x.png`)
    }
    private selectSexDone () {
        this.step = 3 // 下一步
    }
    // 选择床单样式
    private selectBedStyle (v, event, index) {
        // @ts-ignore
        _hmt.push(['_trackEvent', 'nav', 'click', `quilt${index}`, index])
        event ? event.preventDefault() : (() => 1)()
        this.btnActive = true
        for (const i of this.quilt) {
            i.select = false
        }
        v.select = true
        this._ref('bedRoom').quilt = v.img
        // this._ref('bedRoom').toDrawing().then(() => {
        //     this.step = 4
        // })
    }
    private selectDone () {
        if (!this.btnActive || this.selectDoneLoading) {
            return
        }
        // this.btnActive = false
        this.selectDoneLoading = true
        setTimeout(() => {
            this.selectDoneLoading = false
        }, 1000)
        if (this.$root.configData.type === 'catch') { // catch 需要签名页
            this.step = 4
            return
        }
        this._ref('bedRoom').toDrawing()
        // this._ref('bedRoom').toDrawing().then(() => {
        //     if (this.$root.configData.type === 'reason') {
        //         this.$router.push('./result')
        //     } else {
        //         this.step = 4
        //     }
        // })
    }
    // 删除小鬼
    private removeGhost (index) {
        this.selectGhost.splice(index, 1)
        this._ref('ghost').selectGhosts.splice(index, 1)
        if (this.selectGhost.length <= 2) {
            this.summon = false
        }
        this.eitdMode = false
    }
    private changeGhostName (data) {
        this.selectGhost[data.index].name = data.name
        this._ref('ghost').selectGhosts[data.index].name = data.name
        this.eitdMode = false
    }
    private toResultPage () {
        if (!this.signature) {
            this.$parent.showTips('请认真阅读须知哦')
            return
        }
        // this._ref('bedRoom').toDrawing().then(() => {
        //     this.$router.push('./result')
        // })
        this._ref('bedRoom').toDrawing()
    }
    // 设置适配高度
    private setSize () {
        if ((window.innerHeight / window.innerWidth) < 1.7) {
            this.changeTopMargin = true
        }
        // window.addEventListener('resize', () => {
        //     if ((window.innerHeight / window.innerWidth) < 1.7) {
        //         this.changeTopMargin = true
        //     }
        // })
    }
    private mounted () {
        this.$root.showDownLoad = false
        this.$parent.showDown = false
        if (localStorage.getItem('result')) {
            localStorage.removeItem('result')
            this.$router.push('./home')
            return
        }
        if (this.$root.configData.type === 'reason' && !localStorage.getItem('name')) {
            this.showName = true
        }
        this.setSize()
        for (let i = 1; i < 7; i++) {
            this.quilt.push({
                img: require(`../assets/BED/img_polaroid_quilt${i.toString().padStart(2, '0')}@3x.png`),
                bg: require(`../assets/BED/img_quilt${i.toString().padStart(2, '0')}@3x.png`),
                select: false // 是否被选择
            })
        }
    }
}
